import React from 'react';
import { importFromS3 } from '../../utils/importFromS3';

// Runtime dependency
const InSeasonPlugin: React.FC = React.lazy(() => importFromS3('tcc-in-season-web'));

export const InSeasonPluginContainer: React.FC = () => (
  <InSeasonPlugin />
);
